/**
 * @ngdoc directive
 * @name WebCoreModule.directive:wcFileUploadImage
 * @restrict E
 * @element div
 * @description
 * The wcFileUploadImage directive includes the html for upload photo.The upload can be done in two ways
 * one using uploading the image that is already available with the user and the other way is to take a photo
 * using the user's webcam and upload the image.
 */

angular.module('WebCoreModule')
	.directive('wcFileUploadImage', function() {
		var template = [
			'<div ng-show="ctrl.webcamPresent" class="row">',
				'<div class="col-md-12">',
					'<div class="row">',
						'<div class="col-md-3 col-md-offset-1" id="wc-file-upload-image-camera"></div>',
					'</div>',
					'<div class="row">',
						'<div class="col-md-4 col-md-offset-1">',
							'<button type="button" class="btn btn-tertiary " ng-click="ctrl.turnCameraOff()">Camera Off</button>',
							'<button type="button" class="btn btn-tertiary" ng-click="ctrl.turnCameraOn()">Camera On</button>',
							'<button type="button" class="btn btn-primary" ng-click="ctrl.capturePicture()">Take Picture</button>',
						'</div>',
					'</div>',
				'</div>',
			'</div>',
			'<div class="row">',
                '<div class="col-md-12">',
                    '<div class="row">',
                        '<div class="col-md-3 col-md-offset-1">',
                            '<input wc-input-file="ctrl.chooseImageUpload" file-types="ctrl.fileTypes()" class="form-control" type="file" accept="image/">',
                        '</div>',
                    '</div>',
                    '<div class="row">',
                        '<div class="col-md-2 col-md-offset-1">',
                            '<button type="button" class="btn btn-primary" type="submit" ng-click="ctrl.prepareForUpload()">Upload Photo</button>',
                            '<button type="button" class="btn btn-secondary" type="reset" ng-click="ctrl.cancel()">Cancel</button>',
                            '<button type="button" class="btn btn-secondary" type="submit" ng-click="ctrl.addImages()">Add Images</button>',
                        '</div>',
                    '</div>',
                '</div>',
			'</div>'
		].join('');
		return {
			restrict: 'E',
			scope: {},
			bindToController: {
				onUpload: '&',
				fileTypes: '&'
				// thumbnail: '&'
			},
			template: template,
			controllerAs: 'ctrl',
			controller: ['$rootScope', 'WcCameraService', 'WcImageFileService', 'WcDataFileService', '$scope',
				function ($rootScope, WcCameraService, WcImageFileService, WcDataFileService) { // jshint ignore:line

				this.cameraElement = $('#wc-file-upload-image-camera');
				this.chooseImageUpload = null;
				this.snapshotToUpload = null;
				this.webcamPresent = false;

				WcCameraService.checkForCamera().then(angular.bind(this, function(webCamIsPresnet) {
					if(webCamIsPresnet) {
						WcCameraService.setCameraSize(800, 600);
						this.webcamPresent = true;
					}
				})).catch(function(error) {
					console.log(error);
				});

				this.cancel = function() {
					this.chooseImageUpload = null;
					this.snapshotToUpload = null;

					if(this.previewImageElement) {
						this.previewImageElement.remove();
						delete this.previewImageElement;

						this.cameraElement.append(this.videoElement);
						this.videoElement.get(0).play();
					}
				};

				this.capturePicture = function() {
					var snapShot;

					if(this.cameraElement.find('img').length === 0 && WcCameraService.cameraIsOn) {
						snapShot = WcCameraService.takePicture();
						this.previewImageElement = $('<img>').attr('src', snapShot);

						this.videoElement.remove();

						this.cameraElement.append(this.previewImageElement);

						this.snapshotToUpload = snapShot;
					}
				};

				this.prepareForUpload = function() {
					var imageToUpload = this.chooseImageUpload || this.snapshotToUpload;
					var imageToUploadObject = {};

					if(imageToUpload && typeof imageToUpload !== 'string' && imageToUpload.length > 0) {
						WcDataFileService.readFile(imageToUpload[0]).then(function(imageURI) {
							var imageFileData = WcDataFileService.prepareForFileUpload(imageURI);
							imageToUploadObject.imageBase64String =imageFileData.base64String;
							imageToUploadObject.imageMIMEType =imageFileData.MIMEType;
							imageToUploadObject.fileType = WcDataFileService.getFileType(imageToUpload[0]);
							imageToUploadObject.description = '...';

							return WcImageFileService.createImageURI(imageURI);
						})
						.then(angular.bind(this, function(thumbnailURI) {
							var thumbnailFileData = WcDataFileService.prepareForFileUpload(thumbnailURI);
							imageToUploadObject.thumbnailBase64String =thumbnailFileData.base64String;
							imageToUploadObject.thumbnailMIMEType =thumbnailFileData.MIMEType;

							this.onUpload({imageObject: imageToUploadObject});
							this.cancel();

							this.original = $('<img>').attr('src', imageToUploadObject.imageData);
							this.thumb = $('<img>').attr('src', thumbnailURI);
						}));

					} else if (typeof imageToUpload === 'string') {
						WcImageFileService.createImageURI(imageToUpload).then(angular.bind(this, function(thumbnailURI) {
							imageToUploadObject.imageData = imageToUpload;
							imageToUploadObject.thumbnailData =	thumbnailURI;
							imageToUploadObject.fileType = 'jpeg';
							imageToUploadObject.description = '...';

							this.original = $('<img>').attr('src', imageToUploadObject.imageData);
							this.thumb = $('<img>').attr('src', imageToUploadObject.thumbnailData);

							this.onUpload({imageObject: imageToUploadObject});
							this.cancel();

						}));
					}
				};

				this.turnCameraOff = function() {
					WcCameraService.stopCamera();
					this.videoElement.remove();
				};

				this.turnCameraOn = function() {
					if(this.webcamPresent && !WcCameraService.cameraIsOn) {

						WcCameraService.returnVideoElement().then(angular.bind(this, function(videoElement) {
							this.videoElement = videoElement;

							$('#wc-file-upload-image-camera').append(this.videoElement);
							WcCameraService.startCamera();
						})).catch(function(error) {
							console.log(error);
						});
					}
				};
			}],
			link: function(scope, element, attr, ctrl) { // jshint ignore:line
				ctrl.addImages = function() {
					element.append(ctrl.original);
					element.append(ctrl.thumb);
				};
			}

		};
	}
);
